import './hmNav';
import dataStore from './dataStore';

function navDropdown() {
    const config = {
        sensitivity: 3, // number = sensitivity threshold (must be 1 or higher)
        interval: 0,  // number = milliseconds for onMouseOver polling interval
        over: doOpen,   // function = onMouseOver callback (REQUIRED)
        timeout: 0,   // number = milliseconds delay before onMouseOut
        out: doClose    // function = onMouseOut callback (REQUIRED)
    };

    function doOpen() {
        if ($(this).hasClass('menu-item-has-children')) {
            $(this).addClass('hover');
            $('ul:first', this).addClass('vis');
        }
    }

    function doClose() {
        if ($(this).hasClass('menu-item-has-children')) {
            $(this).removeClass('hover');
            $('ul:first', this).removeClass('vis');
        }
    }

    $('#mainnavCon ul li').hoverIntent(config);
}

// Herrliches Menu v2
export const herrlichesMenu = {
    init: () => {
        if (!dataStore.touch && dataStore.docWidth > dataStore.touchBreakPoint) {
            const $headerMenu = $('#header-menu');
            // Alle Top-Level-Items (ohne bereits eingefügtes "Mehr")
            const $allItems = $headerMenu.children('li').not('.more-links');
            // Alle anderen Items, die wir ins "Mehr"-Menü schieben dürfen
            const $overflowItems = $allItems.not('.clicktriggercontact');

            // Erstmal das "Mehr"-Item anfügen (leer)
            const $moreButton = $(`
                <li class="more-links menu-item-has-children menu-item">
                    <a href="#"><strong>Mehr</strong></a>
                    <ul class="sub-menu"></ul>
                </li>
            `);
            const $subMenu = $moreButton.find('.sub-menu');

            // Native DOM-Referenz für Breitencheck
            const navEl = $headerMenu.get(0);

            // Rückwärts durchgehen und so lange verschieben, bis kein Overflow mehr
            $overflowItems.toArray().reverse().forEach((li) => {
                // scrollWidth > clientWidth bedeutet: es passt nicht mehr
                if (navEl.scrollWidth > navEl.clientWidth) {
                    $subMenu.prepend(li);
                }
            });

            if ($subMenu.children().length > 0) {
                $headerMenu.append($moreButton);
            }
        }

        navDropdown();
    },

    destroy: () => {
        const $headerMenu = $('#header-menu');
        const $moreButton = $('.more-links');
        const $menuItems = $moreButton.find('.menu-item');

        if ($menuItems.length > 0) {
            $menuItems.toArray().forEach((item) => {
                const $item = $(item);
                $headerMenu.append($item);
            });

            $moreButton.remove();
        }
    }
};

/* Mobile Submenu  ++++++++++++++++++++++++++++++++++++++++++*/
export function mobileSubmenu() {
    // console.log(dataStore.docWidth);
    // console.log(dataStore.touchBreakPoint);
    if (dataStore.touch === true || dataStore.docWidth < dataStore.touchBreakPoint) {
        let mobileSubmenuFlag = true;

        $('.menuPlus').off('touchStart click').on('touchStart click', (event) => {
            if (mobileSubmenuFlag === true) {
                const $target = $(event.currentTarget);
                mobileSubmenuFlag = false;

                $target.toggleClass('active');
                $target.siblings('.sub-menu').slideToggle(250, 'swing', () => {
                    mobileSubmenuFlag = true;
                });
            }
        });
    }
}

/* HM Nav  Init ++++++++++++++++++++++++++++++++++++++++++*/
export function hmNavInit() {
    /* Mobile NAV ++++++++++++++++++++++++++++++++++++++++++*/
    $('#navToggle').click(() => {
        const nav = $('#mainnavCon');

        $('#navToggle, #mainnavCon, body').toggleClass('open');

        if (nav.hasClass('open')) {
            setTimeout(() => {
                nav.addClass('overflowScroll');
            }, 300);
        } else {
            nav.removeClass('overflowScroll');
        }
    });

    /* NAV more ++++++++++++++++++++++++++++++++++++++++++*/
    herrlichesMenu.init();

    /* Mobile Submenu  ++++++++++++++++++++++++++++++++++++++++++*/
    mobileSubmenu();

    // zIndex Menu
    if ($('ul.sub-menu').length) {
        let zIndex = 1;

        $('#header-menu li.menu-item').mouseover(() => {
            $(this).css('z-index', zIndex);
            zIndex++;
        });
    }

    // Button in nav
    document.querySelectorAll('li.btn').forEach((li) => {
        const link = li.querySelector('a[href]');
        if (!link) return;

        if (li.classList.contains('btn')) {
            li.classList.remove('btn');
            link.classList.add('btn');
        }
    });
}

export default { herrlichesMenu, mobileSubmenu, hmNavInit };
